import { injectable } from "tsyringe";
import {
  DutyTaxConfigurationListFilter,
  DutyTaxConfigurationListResult,
  DutyTaxResolveParams,
  DutyTaxResolveResult
} from "@/domain/entities/DutyTaxConfiguration";
import { DutyTaxConfigurationRepositoryInterface } from "@/data/persistences/repositories/contracts/DutyTaxConfigurationRepositoryInterface";
import {
  DutyTaxConfigurationListRequest,
  DutyTaxResolveApiRequest
} from "@/data/payload/api/DutyTaxConfigurationApiRequest";
import { DutyTaxConfigurationMapper } from "@/data/persistences/mappers/DutyTaxConfigurationMapper";
import { Endpoints } from "../../misc/Endpoints";
import ApiService from "../../services/ApiService";

@injectable()
export class DutyTaxConfigurationApiRepository
  implements DutyTaxConfigurationRepositoryInterface {
  private service: ApiService;
  private mapper: DutyTaxConfigurationMapper;
  private endpoints: Endpoints;

  constructor(
    service: ApiService,
    mapper: DutyTaxConfigurationMapper,
    endpoints: Endpoints
  ) {
    this.service = service;
    this.mapper = mapper;
    this.endpoints = endpoints;
  }

  async getList(
    params: DutyTaxConfigurationListFilter
  ): Promise<DutyTaxConfigurationListResult> {
    const query = DutyTaxConfigurationListRequest.fromFilter(params);
    const resp = await this.service.invoke(
      "get",
      this.endpoints.getDutyTaxConfigurationList(query),
      {}
    );
    return this.mapper.convertListFromApi(resp);
  }

  async resolve(
    params: DutyTaxResolveParams
  ): Promise<DutyTaxResolveResult | null> {
    const resp = await this.service.invoke(
      "post",
      this.endpoints.resolveDutyTaxConfiguration(),
      undefined,
      new DutyTaxResolveApiRequest(params)
    );
    return this.mapper.convertResolveFromApi(resp);
  }
}
